import Vue from 'vue';

Vue.filter('truncate', (text, length, suffix) => {
    if (!text) return '';
    if (text.length <= length) return text;
    suffix = suffix || '...';
    text = text.toString();
    return text.substring(0, length) + suffix;
});
  
Vue.filter('pluralize', (word, amount, plural) => {
    let singularText = word;
    let pluralText = (plural) ? plural: `${word}s`;
    return (amount > 1 || amount == 0) ? pluralText : singularText;
});

Vue.filter('imagekit', (src,transform)=>{
    if(src.includes("csg-cdn.s3.amazonaws.com")){
        var id = src.split("/")[3];
        return `https://ik.imagekit.io/csuite/${id}?tr=${transform}`;
    }
    else{
        return src;
    }
    //return null;
    //return src;
});

Vue.filter('formatNumber', value => { 
    return value ? value.toLocaleString(): value;
});
